import { Injectable } from '@angular/core'
import { Http, Response, URLSearchParams, Headers } from '@angular/http'

import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'

import { Movie, Theatre } from '../../shared/movie.model'

import * as moment from 'moment'

@Injectable()
export class MovieService {
    private static readonly API_BASE_URL = 'https://data.tmsapi.com/v1.1'
    private headers: Headers

    constructor(private http: Http) {
        this.headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        })
    }

    public getMovies(lang?: string): Observable<Movie[]> {
        const params = new URLSearchParams()
        params.set('startDate', moment().format('YYYY-MM-DD'))
        params.set('numDays', '7')
        params.set('lat', '45.55799439258627')
        params.set('lng', '-73.54851007461548')
        params.set('radius', '10')
        params.set('units', 'km')
        params.set('imageText', 'true')
        params.set('lang', lang)
        params.set('api_key', '9h6jvc6de4ez8xwy53khs5bw')

        return this.http.get(MovieService.API_BASE_URL + '/movies/showings', { search: params, headers: this.headers })
            .map((response: Response) => {
                const json = response.json()
                const movies: Movie[] = this.parseMovies(json)

                return movies
            })
            .do(a => console.log(a))
            .catch((error: any) => Observable.throw(error))
    }

    public getTheatres(lang?: string): Observable<Theatre[]> {
        const params = new URLSearchParams()
        params.set('lat', '45.55799439258627')
        params.set('lng', '-73.54851007461548')
        params.set('radius', '10')
        params.set('units', 'km')
        params.set('lang', lang)
        params.set('api_key', '9h6jvc6de4ez8xwy53khs5bw')

        return this.http.get(MovieService.API_BASE_URL + '/theatres', { search: params, headers: this.headers})
            .map((response: Response) => {
                let theatres: Theatre[] = []
                const json = response.json()

                for (const item of json) {
                    const theatre: Theatre = {
                        id: item.theatreId,
                        name: item.name,
                        distance: item.location.distance
                    }

                    theatres.push(theatre)
                }

                theatres = theatres.sort((a: Theatre, b: Theatre) => {
                    return a.distance - b.distance
                })

                return theatres
            })
            .catch((error: any) => Observable.throw(error))
    }

    public getShowtimesbyTheatre(theatreId: number, lang?: string): Observable<Movie[]> {
        const params = new URLSearchParams()
        params.set('startDate', moment().format('YYYY-MM-DD'))
        params.set('numDays', '7')
        params.set('imageText', 'true')
        params.set('lang', lang)
        params.set('api_key', '9h6jvc6de4ez8xwy53khs5bw')

        return this.http.get(MovieService.API_BASE_URL + `/theatres/${theatreId}/showings`, { search: params, headers: this.headers})
            // .do((response) => console.log(response.json()))
            .map((response: Response) => {
                const json = response.json()
                const movies: Movie[] = this.parseMovies(json)

                for (let i = 0 ; i < movies.length ; i++) {
                  movies[i].showtimesByTheatre[0].theatre.id = theatreId
                }

                console.log(movies)

                return movies
            })
    }

    private parseMovies(json: any): Movie[] {
        const groupMovies = this.groupBy(json, 'rootId')

        const movies: Movie[] = []

        for (const rootId in groupMovies) {
            if (groupMovies.hasOwnProperty(rootId)) {
                const movie: Movie = new Movie()

                for (const movieResponse of groupMovies[rootId]) {
                    movie.deserialize(movieResponse)
                }

                movies.push(movie)
            }
        }

        movies.sort((a: Movie, b: Movie) => {
            const titleA = a.getTitle('en').toLowerCase()
            const titleB = b.getTitle('en').toLowerCase()
            return (titleA < titleB) ? -1 : (titleA > titleB) ? 1 : 0
        })

        return movies
    }

    private groupBy(xs: any[], key: string): any[] {
      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x)
        return rv
      }, {})
    }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/core/movies/movie.service.ts